import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=b950cf76&scoped=true"
import script from "./ServiceCard.vue?vue&type=script&lang=js"
export * from "./ServiceCard.vue?vue&type=script&lang=js"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=b950cf76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b950cf76",
  null
  
)

export default component.exports